import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-33ad1794")

_pushScopeId("data-v-33ad1794")
const _hoisted_1 = { class: "password-reset-request" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "パスワードリセット", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "description" }, "登録済みのメールアドレスを入力してください。パスワードリセット用のリンクをお送りします。", -1)
const _hoisted_4 = {
  key: 0,
  class: "success"
}
const _hoisted_5 = {
  key: 1,
  class: "error"
}
const _hoisted_6 = {
  key: 2,
  class: "error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TextField = _resolveComponent("TextField")
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createVNode(_component_TextField, {
        class: "email-field",
        label: "メールアドレス",
        type: "email",
        modelValue: _ctx.state.email,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.email = $event))
      }, null, 8, ["modelValue"]),
      (_ctx.successMessage)
        ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.successMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.localizationError != null)
        ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.localizationError.message), 1))
        : _createCommentVNode("", true),
      (_ctx.state.validationError)
        ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.state.validationError), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_BaseRoundRectButton, {
        class: "submit-button",
        text: "送信",
        onClick: _ctx.handleSubmit,
        isPushed: _ctx.isLoading
      }, null, 8, ["onClick", "isPushed"])
    ], 32)
  ]))
})